<template>
  <div class="enterprise-list-page enterprise-list-page--doctors">

    <!-- Header Card -->
        <PageHeader v-if="!embedded" icon="fas fa-user-md">
      <template #title>
        Daftar Dokter {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola data dokter, spesialisasi, dan jadwal praktik
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                v-if="manipulateBtn == true"
                @click="$router.push('/doctor/add')">
                <i class="fas fa-plus"></i>
                <span>Tambah Dokter</span>
              </b-button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-12">
        <Card>
          <template v-slot:body>
            <Table purpose="master" />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Table from '@/component/doctors/Table.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  props: {
    embedded: { type: Boolean, default: false }
  },

  components: {
    Card,
    Table
  },

  data() {
    return {
      manipulateBtn: false,
      clinic_name: "Medhop"
    }
  },

  methods: {
    // access management
    async setActiveMenu() {

      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {

        if (access_right[a] == "2002") {
          this.manipulateBtn = true
        }
      }
    },
  },

  mounted() {
    this.setActiveMenu()
    this.clinic_name = window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    // BreadCrumb
    if (!this.embedded) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Dokter" },
        { title: "Daftar Dokter" },
      ])
    }
  },

}
</script>
